// extracted by mini-css-extract-plugin
module.exports = {"sectionG":"SectionG_sectionG__6q2EO"};